// extracted by mini-css-extract-plugin
export default {"container":"Overlay_container__xlG3q","overlay":"Overlay_overlay__QF9k0"};